import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import React, { MouseEventHandler, useState } from "react"

type ButtonSplitProps = {
    label: string
    onLeftClick?: MouseEventHandler<HTMLButtonElement>
    leftIcon?: Icons.IconComponent
    onRightClick?: MouseEventHandler<HTMLButtonElement>
    disabled?: boolean
}

export const ButtonSplit = ({
    label,
    onLeftClick,
    leftIcon = Icons.ArrowDropdown,
    onRightClick,
    disabled,
}: ButtonSplitProps) => {
    const [hoveringLeft, setHoveringLeft] = useState(false)
    const [pressingLeft, setPressingLeft] = useState(false)
    const [hoveringRight, setHoveringRight] = useState(false)
    const [pressingRight, setPressingRight] = useState(false)
    return (
        <div className="flex">
            <button
                onClick={onLeftClick}
                onMouseEnter={() => setHoveringLeft(true)}
                onMouseLeave={() => setHoveringLeft(false)}
                onMouseDown={() => setPressingLeft(true)}
                onMouseUp={() => setPressingLeft(false)}
                disabled={disabled}
                className={classNames(
                    "flex items-center gap-2 px-3 py-1.5 bg-gray-700 text-sm rounded-l-lg border-t border-b border-l transition-colors",
                    "disabled:cursor-not-allowed disabled:opacity-50",
                    {
                        "border-gray-500 text-gray-100":
                            !hoveringLeft && !pressingLeft && !disabled,
                        "border-white text-white": hoveringLeft && !pressingLeft && !disabled,
                        "border-gray-300 text-white": pressingLeft && !disabled,
                    }
                )}
            >
                <span>{label}</span>
                <Icons.SmallIcon Icon={leftIcon} />
            </button>
            <div className="self-stretch w-px py-px">
                <div
                    className={classNames("w-full h-full transition-colors", {
                        "bg-gray-500":
                            (!hoveringLeft && !hoveringRight && !pressingLeft && !pressingRight) ||
                            disabled,
                        "bg-white":
                            (hoveringLeft || hoveringRight) &&
                            !pressingLeft &&
                            !pressingRight &&
                            !disabled,
                        "bg-gray-300": pressingLeft || (pressingRight && !disabled),
                    })}
                />
            </div>
            <button
                onClick={onRightClick}
                onMouseEnter={() => setHoveringRight(true)}
                onMouseLeave={() => setHoveringRight(false)}
                onMouseDown={() => setPressingRight(true)}
                onMouseUp={() => setPressingRight(false)}
                disabled={disabled}
                className={classNames(
                    "flex items-center justify-center px-1 bg-gray-700 text-sm rounded-r-lg border-t border-b border-r transition-colors",
                    "disabled:cursor-not-allowed disabled:opacity-50",
                    {
                        "border-gray-500 text-gray-100":
                            !hoveringRight && !pressingRight && !disabled,
                        "border-white text-white": hoveringRight && !pressingRight && !disabled,
                        "border-gray-300 text-white": pressingRight && !disabled,
                    }
                )}
            >
                <Icons.Icon Icon={Icons.Close} iconClassName="!m-0" />
            </button>
        </div>
    )
}
